
    import JobCardBasic from '@/components/Job/JobCard/JobCardBasic';
    import Slide from '@/components/Utils/Slide';

    export default {
        name: 'JobSlide',

        components: {
            Slide,
            JobCardBasic,
        },

        props: {
            jobs: {
                type: Array,
                default: () => ([]),
            },

            to: {
                type: String,
                default: '',
            },

            toLabel: {
                type: String,
                default: '',
            },

            rowLabel: {
                type: String,
                default: '',
            },

            rowType: {
                type: String,
                default: '',
            },

            rowTypeId: {
                type: String,
                default: '',
            },

            rowPosition: {
                type: Number,
                default: 0,
            },

            target: {
                type: String,
                default: '_self',
            },

            slideBreakPoints: {
                type: Object,
                default: () => {},
            },
        },

        data() {
            return {
                id: this._uid,
            };
        },

        computed: {
            firstColSpan() {
                let span = 0;

                if (this.$slots[this.rowTypeId]) {
                    span = this.$mq !== 'sm'
                        ? 2
                        : 1;
                }

                return span;
            },

            hasRowTypeIdSlot() {
                return !!this.$slots[this.rowTypeId];
            },
        },

        methods: {
            goToNext() {
                this.$refs.slide.next();
            },
        },
    };
